<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed bootsnav light" />
    <Banner :title="$t('blog.detail')" />
    <BlogContent :category="category" />
    <Footer :functions="meta.active_functions" />
    <FollowModal />
    <SubscribeModal />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Banner from '@/components/Banner.vue'
import BlogContent from '@/components/blog/BlogContent.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'

export default {
  name: 'blog-detail',
  props: ['meta'],
  data: function () {
    return {
      category: []
    }
  },
  components: {
    Nav,
    Banner,
    BlogContent,
    Footer,
    FollowModal,
    SubscribeModal
  },
  methods: {
    
  },
  created: function() {
    let that = this
    this.$http.get(this.BLOG_API_PREFIX + 'category.html').then(function (response) {
      that.category = response.data.info.category
      let total = 0
      that.category.forEach(function(c, i) {
          total += parseInt(c.num)
          c.value = c.name + ' (' + c.num + ')'
          if (c.children.length > 0) {
            c.children.forEach(function(c1, i1) {
              c1.value = c1.name + ' (' + c1.num + ')'
            })
          }
      })
      that.category.unshift({
        children: [],
        id: 0,
        value: '全部' + ' (' + total + ')',
        name: 'All Careers Advice',
        num: total,
        url_name: 'all'
      })
      console.log(that.category)
    }).catch(function (error) {
      console.log(error)
    });
  }
}
</script>
